import { useDraftStore } from '@/stores/draft-store';
import { useSessionStore } from '@/stores/session-store';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

class ApiClient {
  private async request<T>(method: string, path: string, body?: unknown): Promise<T> {
    const res = await fetch(`${API_BASE}${path}`, {
      method,
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: body ? JSON.stringify(body) : undefined,
    });

    if (res.status === 401) {
      // BK-06 : un brouillon actif ne doit pas être jeté par une redirection
      // dure — la modale de reconnexion préserve l'état SPA (draft compris).
      if (useDraftStore.getState().isActive) {
        useSessionStore.getState().setReauthRequired(true);
      } else {
        window.location.href = '/login';
      }
      throw new Error('Unauthorized');
    }

    if (!res.ok) {
      const error = await res.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error((error as { error?: string }).error || `HTTP ${res.status}`);
    }

    if (res.status === 204) return undefined as T;

    return res.json() as Promise<T>;
  }

  get<T>(path: string) { return this.request<T>('GET', path); }
  post<T>(path: string, body?: unknown) { return this.request<T>('POST', path, body); }
  put<T>(path: string, body?: unknown) { return this.request<T>('PUT', path, body); }
  delete<T>(path: string) { return this.request<T>('DELETE', path); }
}

export const api = new ApiClient();
